import { render, staticRenderFns } from "./alteration.vue?vue&type=template&id=2c4a7298&"
import script from "./alteration.vue?vue&type=script&lang=js&"
export * from "./alteration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports